export default "__VITE_ASSET__e15aba9d__"